/*********************** Custom JS for Boost AI Search & Discovery  ************************/
if (window.boostSDAppConfig.generalSettings) {
  window.boostSDAppConfig.generalSettings.enableCartOnPages = ['index', 'page'];
}

const customize = {
  updateProductGridItem: (componentRegistry) => {
    componentRegistry.useComponentPlugin('ProductItem', {
      name: 'Add Pre-order label',
      enabled: true,
      apply: () => ({
        afterRender(element) {
          try {
            let productData = element.getParams().props.product;
            let productId = productData.id;
            if (productData?.split_product) {
              productId = productData.variant_id
            }
            let productItem = document.querySelector(`.boost-sd__product-item[data-product-id="` + productId + `"] `);
            if (productItem) {
              let variant = productData.variants[0];
              if (variant.inventory_quantity < 1 && variant.inventory_policy == 'continue') {
                let preorderLabel = `<div class="boost-sd__product-label boost-sd__product-label--rectangle boost-sd__product-label--preorder" style="color: rgb(255, 255, 255); background-color: rgb(162, 219, 99);"><span class="boost-sd__product-label-text">Pre Order</span></div>`
                productItem.querySelector('.boost-sd__inventory-status').innerHTML = 'Pre-order';
                if (!productItem.querySelector('.boost-sd__product-label--preorder')) {
                  productItem.querySelector('.boost-sd__product-image-row--bottom .boost-sd__product-image-column--in-bottom').insertAdjacentHTML('beforebegin',preorderLabel);
                }
              }
            }
          } catch (error) {
            console.warn(error)
          }
        }
      })
    });
  }
}

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([customize.updateProductGridItem]);


